module.exports = __webpack_public_path__ + "img/molo.9749ceb8.svg";